import React from "react";
import { BookOpen, FileText, Target, Users, ArrowRight } from "lucide-react";

const features = [
  {
    icon: <BookOpen className="w-6 h-6" />,
    title: "Khóa học đa dạng",
    description: "Hệ thống khoá học đa dạng từ cơ bản tới nâng cao, phù hợp với mọi trình độ học viên."
  },
  {
    icon: <FileText className="w-6 h-6" />,
    title: "Tài liệu phong phú",
    description: "Thư viện tài liệu học tập chất lượng cao, luôn được cập nhật và miễn phí."
  },
  {
    icon: <Target className="w-6 h-6" />,
    title: "Luyện thi thông minh",
    description: "Hệ thống thi thử HSK với giao diện mô phỏng rất giống với cấu trúc đề thi thật, giúp bạn đánh giá năng lực chính xác."
  },
  {
    icon: <Users className="w-6 h-6" />,
    title: "Giảng viên trình độ chuyên môn cao",
    description: "Các giảng viên sở hữu chứng chỉ quốc tế cùng nhiều năm kinh nghiệm giảng dạy tiếng Trung."
  }
];

export default function FeaturesSection() {
  return (
    <section className="py-20 px-4 sm:px-6 lg:px-8 bg-transparent">
      <div className="max-w-7xl mx-auto">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Tại sao chọn 86HSK?
          </h2>
          <p className="text-lg text-gray-600">
            Mở rộng cơ hội nghề nghiệp với chứng chỉ HSK nhờ nền tảng học tập toàn diện của 86 HSK.
          </p>
        </div>

        {/* Features Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {features.map((feature, index) => (
            <div
              key={index}
              className="group bg-white p-8 rounded-2xl border border-gray-200 hover:border-red-200 hover:shadow-lg transition-all cursor-pointer"
            >
              <div className="w-12 h-12 bg-red-50 rounded-xl flex items-center justify-center text-red-600 mb-4 group-hover:bg-red-600 group-hover:text-white transition-colors">
                {feature.icon}
              </div>
              <h3 className="text-xl font-semibold text-gray-900 mb-2">
                {feature.title}
              </h3>
              <p className="text-gray-600 leading-relaxed">
                {feature.description}
              </p>
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <div className="mt-12 flex justify-center">
          <a
            href="https://tiengtrung86hsk.com/lien-he/"
            className="group inline-flex items-center justify-center gap-2 px-8 py-4 bg-[#DC143C] text-white font-semibold rounded-xl hover:bg-red-700 transition-all shadow-lg hover:shadow-xl cursor-pointer"
          >
            <span>Đăng ký ngay</span>
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
          </a>
        </div>
      </div>
    </section>
  );
}